module.exports = __webpack_public_path__ + "static/media/message.5d8d4afa.png";